import { Modal } from "antd";
import { useMediaQuery } from "react-responsive";
import View from "./View";

const Cart = ({ open, onSubmit, onClose, generalCost, upsells }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={isMobile ? "90%" : "500px"}
      centered
      footer={null}
      className="acoris-cart-modal-wrapper B2C_ACORIS"
    >
      <View
        onSubmit={onSubmit}
        onClose={onClose}
        generalCost={generalCost}
        upsells={upsells}
      />
    </Modal>
  );
};

export default Cart;
